import { motion } from "framer-motion";
import { FileText, Clock, ShieldCheck, BadgeCheck } from "lucide-react";
import { PILLARS } from "@/data/site";

const ICONS = { FileText, Clock, ShieldCheck, BadgeCheck };

export default function WhyUs() {
  return (
    <section id="why-us" className="border-t border-zinc-800 bg-zinc-900 py-24 lg:py-32" data-testid="why-us-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.4 }}
          >
            <p className="font-mono-industrial text-xs font-semibold uppercase tracking-[0.25em] text-orange-500">
              Why choose us
            </p>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">
              We treat it like our own place
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-zinc-400">
              Straight talk, fair prices and work we're happy to put our name on. That's why
              locals keep our number on the fridge.
            </p>
          </motion.div>

          <div className="flex flex-col gap-4">
            {PILLARS.map((p, i) => {
              const Icon = ICONS[p.icon];
              return (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.35, delay: i * 0.07 }}
                  className="flex gap-6 border border-zinc-800 border-l-4 border-l-orange-600 bg-zinc-950 p-6"
                  data-testid={`pillar-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <span className="mt-1 flex h-11 w-11 shrink-0 items-center justify-center bg-orange-600 text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight text-white">{p.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-zinc-400">{p.text}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
